<template>
  <div>
    <van-overlay :show="show">
      <div class="wrapper" @click.stop>
        <div class="block" >
          <div class="share-icon">
            <img src="@/assets/img/share-sheet-qzone.png" alt="" @click="goQzone">
            <img src="@/assets/img/share-sheet-weibo.png" alt="" @click="goWeibo">
            <img src="@/assets/img/share-sheet-wechat.png" alt="" @click="goWechat">
          </div>
          <div class="search-code" v-show="codeShow">
            <div id="qrcodeImg"></div>
            <div>微信扫一扫：分享</div>
            <div class="triangle_border_down">
              <span></span>
            </div>
          </div>
          <p @click="close">取消</p>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import {request} from '../untils/request' // 引入qrcode
export default {
  name: 'pageShare',
  data () {
    return {
      codeShow: false
    }
  },
  props: {
    show: {
      type: Boolean
    },
    title: {
      type: String
    }
  },
  computed: {

  },
  mounted () {
    this.qrcode()
  },
  methods: {
    close () {
      this.$emit('show', false)
      this.codeShow = false
    },
    qrcode () {
      new QRCode('qrcodeImg', {
        width: 100,
        height: 100,
        text: location.href, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff'
      })
    },
    goWechat () {
      if (this.codeShow === true) {
        this.codeShow = false
      } else {
        this.codeShow = true
      }
    },
    goQzone () {
      let p = {
        url: location.href.replace('http://',''),
        title: this.title || document.title,/*分享标题(可选)*/
        site: 'summary',/*分享来源 如：腾讯网(可选)summary*/
      }
      let s = [];
      for (let i in p) {
        s.push(i + '=' + encodeURIComponent(p[i] || ''));
      }
      let target_url = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?"+s.join('&')
      console.log('target_url',target_url)
      window.open(target_url, 'qZone')
    },
    goWeibo () {
      console.log('title',document.title);
      let param = {
        url: location.href,
        appkey: '1343713053', /** 您申请的应用appkey,显示分享来源(可选)*/
        title: this.title || document.title, /** 分享的文字内容(可选，默认为所在页面的title)*/
      }
      let temp = [];
      for( let p in param ){
        temp.push(p + '=' + encodeURIComponent( param[p] || '' ) )
      }
      let target_url = "http://service.weibo.com/share/share.php?"+temp.join('&');
      window.open(target_url, 'sinaweibo')
    }
  }
}
</script>

<style scoped>
.wrapper {
  width:100%;
  position:absolute;
  bottom:0;
  left:0;
  background:#f7f8fa;
  border-radius: 16px 16px 0 0;
}

.block {
  width: 96%;
  height: 2.5rem;
  background-color: #fff;
  padding:2% 2% 0 2%;
  border-radius: 16px 16px 0 0;
  position:relative;
}
.block p{
  font-size:.24rem;
  width:98%;
  height:1rem;
  text-align:center;
  line-height:1rem;
  border-top:1px solid #B3BBC3;
  margin:0;
  position:absolute;
  bottom:0;
  left:1%;
  right:1%;
}
.share-icon{
  padding-top:.23rem;
}
.share-icon img{
  width:.96rem;
  height:.96rem;
  margin-left:.3rem;
}
#qrcodeImg{
  width:2rem;
  height:2rem;
  margin: 0 auto;
}
.search-code{
  position: absolute;
  left: 2.5rem;
  top: -3.2rem;
  z-index:999;
  width:2.8rem;
  height:2.6rem;
  border-radius:16px;
  background:#fff;
  font-size:.2rem;
  padding-top:.4rem;
  text-align:center;
}
.triangle_border_down{
  width:0;
  height:0;
  border-width:20px 20px 0;
  border-style:solid;
  border-color:#fff transparent transparent;
  position:absolute;
  bottom:-.2rem;
  left:.95rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pageShare.vue